module.exports = __webpack_public_path__ + "img/C03TechWoadRaiderMaster_ua.efaf22d0.webp";